import React, { useState, useEffect, useCallback } from "react";
import axiosConfig from "../config.js";

import FilteringSidebar from "../components/dashboard/FilteringSidebar.jsx";
import PatientTable from "../components/dashboard/PatientTable.jsx";
import Pagination from "../components/dashboard/Pagination.jsx";

import PatientForm from "../components/forms/PatientForm.jsx";
import OperationForm from "../components/forms/OperationForm.jsx";
import CreationPopup from "../components/forms/CreationForm.jsx";
import SearchBar from "../components/dashboard/SearchBar.jsx";
// To do-list: lodash to big dependencies 
// import { debounce } from 'lodash';


const PatientDashboard = () => {

  //YEET NEXT COMMIT PROBABLY const [patientData, setPatientData] = useState([]); // no longer needed, since patient data is aggregated into the results on backend already bro 💀

  // Using operations since the backend is now returning operations with relevant data for searching, not patients.
  const [operations, setOperations] = useState([]);

  // Loading and error 
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // State for paginiation 
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  // State for search and filters
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState({});  

  // State for sorting 
  const [isSorted, setIsSorted] = useState(false);
  const [sortBy, setSortBy] = useState("priorityScore");
  const [sortOrder, setSortOrder] = useState("desc");

  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isPatientFormVisible, setIsPatientFormVisible] = useState(false);
  const [isOperationFormVisible, setIsOperationFormVisible] = useState(false);



  const getOperationData = useCallback(
    async () => {
      try {

        setLoading(true); 
        setError(null);

      const res = await axiosConfig.get("/operation",  {
        params: {
          pageSize: pageSize, 
          page: page, 
          sortBy: sortBy, 
          sortOrder: sortOrder, 
          search: search,

          filter: JSON.stringify(filter)
        }
      });

      const data = res.data; 

      // Update state with the fetched data 
      setOperations(data.operations);
      setTotalPages(data.totalPages);
      
    } 
      catch (error) {
        console.error("Error fetching operation data: ", error);
        // amazing error message 
        setError("Failed to load operation data. Please try again later. (-_-)<3 ");
      }
      finally {
        setLoading(false);
      }
    }, 
    [pageSize, page, sortBy, sortOrder, search, filter]
  );

  useEffect(() => {
    getOperationData();
  }, [getOperationData]) ;

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };  
  


  /** [Hell is empty] All the sorting stuff is -down- here */

  /*
      If the same (table) header's clicked, toggle direction (e.g. from asc to desc). 
   *  If a new (table) header's clicked then this is assigned as the new key, and the default sort direction is switched to descending. 
   */

  const handleSort = (key) => {
    if (sortBy === key) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    }
    else {
      setSortBy(key);
      setSortOrder("desc");
    }

    setIsSorted(true); 
    setPage(1);  // sets the page to 1, when sorting is done (for utility's sake)
  }

  const triggerSearch = () => {
    const query = search.trim(); 
    if (query === "") {
      setSearch(""); // Yeet input query if empty
    }
    getOperationData(query); // Fetch data w updated query
  };


  /**
   * Handle filters coming from the Sidebar component
   * This function transforms the sidebar filters into the MongoDB-style filter format
   * expected by your backend API
   */
  const handleSidebarFilters = (sidebarFilters) => {
    // Create a new filter object in the format expected by your MongoDB backend
    const mongoDBFilter = {};
    
    // Process operation type
    if (sidebarFilters.operationType) {
      // Convert comma-separated string to array of values
      const operationTypes = sidebarFilters.operationType.split(',').map(el => parseInt(el));
      // Use $in operator for array values in MongoDB
      mongoDBFilter.operationType = { $in: operationTypes };
    }
    
    // Handle boolean fields
    if (sidebarFilters.ntcSuitability !== undefined) {
      mongoDBFilter.ntcSuitability = sidebarFilters.ntcSuitability;
    }
    
    if (sidebarFilters.ntcAttendance !== undefined) {
      mongoDBFilter.ntcAttendance = sidebarFilters.ntcAttendance;
    }
    
    if (sidebarFilters.roboticSurgery !== undefined) {
      mongoDBFilter.roboticSurgery = sidebarFilters.roboticSurgery;
    }
    
    if (sidebarFilters.preassessmentPassed !== undefined) {
      mongoDBFilter.preassessmentPassed = sidebarFilters.preassessmentPassed;
    }
    
    if (sidebarFilters.bedRequired !== undefined) {
      mongoDBFilter.bedRequired = sidebarFilters.bedRequired;
    }
    
    // Handle surgery side
    if (sidebarFilters.surgerySide) {
      mongoDBFilter.surgerySide = sidebarFilters.surgerySide;
    }
    
    // Handle SIMD (Scottish Index of Multiple Deprivation)
    if (sidebarFilters.simd) {
      mongoDBFilter.simd = sidebarFilters.simd;
    }
    
    // Handle date ranges for theatre date
    if (sidebarFilters.theatreDateRangeStart || sidebarFilters.theatreDateRangeEnd) {
      mongoDBFilter.theatreDate = {};
      
      if (sidebarFilters.theatreDateRangeStart) {
        mongoDBFilter.theatreDate.$gte = new Date(sidebarFilters.theatreDateRangeStart);
      }
      
      if (sidebarFilters.theatreDateRangeEnd) {
        mongoDBFilter.theatreDate.$lte = new Date(sidebarFilters.theatreDateRangeEnd);
      }
    }
    
    // Handle priority score range
    if (sidebarFilters.priorityScoreRangeMin || sidebarFilters.priorityScoreRangeMax) {
      mongoDBFilter.priorityScore = {};
      
      if (sidebarFilters.priorityScoreRangeMin) {
        mongoDBFilter.priorityScore.$gte = parseFloat(sidebarFilters.priorityScoreRangeMin);
      }
      
      if (sidebarFilters.priorityScoreRangeMax) {
        mongoDBFilter.priorityScore.$lte = parseFloat(sidebarFilters.priorityScoreRangeMax);
      }
    }
    
    // Update the filter state which will trigger a data fetch
    setFilter(mongoDBFilter);
    setPage(1); // Reset to page 1 when applying new filters
  };

    
const openForm = () => { // open the form
    setIsPopupVisible(true); // open the popup
}

const closeForm = () => { // close the form
    setIsPopupVisible(false); // close the popup
}

const isFormVisible = isPatientFormVisible || isOperationFormVisible; // check if either form is visible
      
  const openPatientForm = () => { setIsPatientFormVisible(true); }; // open the form
  const closePatientForm = () => { setIsPatientFormVisible(false); }; // close the form

  const openOperationForm = () => { setIsOperationFormVisible(true); }; // open the form
  const closeOperationForm = () => { setIsOperationFormVisible(false); }; // close the form
  

  const handlePatientSubmit = async (e) => { // handles the patient form submission
    e.preventDefault(); 

    const patientData = {
      chi: e.target.chi.value,
      surname: e.target.surname.value,
      forename: e.target.forename.value,
      dob: e.target.dob.value,
      sex: e.target.sex.value,
      postcode: e.target.postcode.value,
    }; // patient data object

    try { // try to post the patient data to the server
      await axiosConfig.post("/patients", patientData);
      closeForm(); // close the form if successful
    } catch (error) {
      console.error("Error creating patient:", error.message);
    }
  };

  const handleOperationSubmit = async (e) => { // handles the operation form submission
    e.preventDefault();

    const operationData = {
      chi: e.target.chi.value,
      operationType: e.target.operationType.value,
      waitingSince: e.target.waitingSince.value,
      painLevel: e.target.painLevel.value,
      radioSeverity: e.target.radioSeverity.value,
      adl: e.target.adl.value,
      mobility: e.target.mobility.value,
      surgeonId: e.target.surgeonId.value,
      surgerySide: e.target.surgerySide.value,
      ntcSuitability: e.target.ntcSuitability.value,
      ntcAttendance: e.target.ntcAttendance.value,
      theatreDate: e.target.theatreDate.value,
      roboticSurgery: e.target.roboticSurgery.value,
      bedRequired: e.target.bedRequired.value,
      preassessmentPassed: e.target.preassessmentPassed.value,
      workOrCareImpairment: e.target.workOrCareImpairment.value,
      mentalHealthImpairment: e.target.mentalHealthImpairment.value,
    }; // operation data object

    try {
      await axiosConfig.post(`/patients/${operationData.chi}/operations`, operationData);
      closeForm(); // close the form if posting operation data is successful
    } catch (error) {
      console.error("Error creating operation:", error.message);
    }
  };



  return (
    <div className="app">
      <div className="main-content">
        <div className="sort-section">
          <SearchBar setSearch={setSearch} onSearch={triggerSearch} debounce />
        </div>

 
        {isPatientFormVisible && (
          <PatientForm onSubmit={handlePatientSubmit} onClose={closePatientForm} />
        )}

        {isOperationFormVisible && (
          <OperationForm onSubmit={handleOperationSubmit} onClose={closeOperationForm} />
        )}

        <div className="table-section">
          {loading ? (
            <p>Loading...</p>
          ) : error ? (
            <p className="error-message">{error}</p>
          ) : (
            <>
              <div className="patient-table-section">
                <PatientTable data={operations} 
                sortBy={sortBy} sortOrder={sortOrder} onSort={handleSort} isSorted={isSorted} 
                /> 
              </div>
              <Pagination 
                page={page} pageSize={pageSize} totalPages={totalPages} 
                onPageChange={handlePageChange} onPageSizeChange={setPageSize}
              />
            </>
          )}
        </div>
      </div>
      
      <div className="sidebar-wrapper">
        <FilteringSidebar onCategoryChange={handleSidebarFilters} />
        
        {/* Popup sticks to the left side of the sidebar */}
        <div className="popup-wrapper">
            <CreationPopup 
                openPatientForm={openPatientForm}
                openOperationForm={openOperationForm}
            />
        </div>
      </div>
    </div>
  );
};

export default PatientDashboard;